<template>
  <analytics-sub-page
    title="Analytics"
    icon="chart-pie"
    css-class="analytics-homepage"
    default-label="Summary"
    :get-sheet-config="getSheetConfig"
  >
    <snapshot-metrics ref="snapshotRef" />
    <adoption-metrics />
    <app-logins-metrics />
    <app-features-metrics />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import AdoptionMetrics from '@/pages/analyticsHomepage/components/AdoptionMetrics.vue';
import AppFeaturesMetrics from '@/pages/analyticsHomepage/components/AppFeaturesMetrics.vue';
import AppLoginsMetrics from '@/pages/analyticsHomepage/components/AppLoginsMetrics.vue';
import SnapshotMetrics from '@/pages/analyticsHomepage/components/SnapshotMetrics.vue';

const snapshotRef = ref(null);

const getSheetConfig = () => snapshotRef.value?.getPdfData?.() || {};
</script>
